import { render, staticRenderFns } from "./updateMunicipality.vue?vue&type=template&id=712b86bc&"
import script from "./updateMunicipality.vue?vue&type=script&lang=js&"
export * from "./updateMunicipality.vue?vue&type=script&lang=js&"
import style0 from "./updateMunicipality.vue?vue&type=style&index=0&id=712b86bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports